import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Clock } from 'lucide-react';
import { blogPosts } from '../data/blogPosts';
interface Props {
  onViewAll: () => void;
  onSelectPost: (slug: string) => void;
}
export function BlogPreview({
  onViewAll,
  onSelectPost
}: Props) {
  const previewPosts = blogPosts.slice(0, 3);
  return <section id="blog" className="py-24 md:py-32 bg-surface border-t border-border" data-id="element-72">
      <div className="container mx-auto px-6" data-id="element-73">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6" data-id="element-74">
          <div data-id="element-75">
            <div className="w-12 h-1 bg-accent mb-6" data-id="element-76" />
            <h2 className="text-3xl md:text-5xl font-heading" data-id="element-77">
              Insights aus dem House of AI
            </h2>
          </div>
          <button onClick={onViewAll} className="inline-flex items-center gap-2 text-accent hover:text-accent-hover font-medium transition-colors group" data-id="element-78">
            Alle {blogPosts.length} Artikel lesen
            <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" data-id="element-79" />
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-80">
          {previewPosts.map((post, index) => <motion.article key={post.slug} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.6
        }} onClick={() => onSelectPost(post.slug)} className="group cursor-pointer" data-id="element-81">
              <div className="bg-[#020611] border border-border p-8 h-full flex flex-col transition-all duration-300 group-hover:-translate-y-2 group-hover:border-accent/50 group-hover:shadow-[0_10px_30px_rgba(0,0,0,0.5)]" data-id="element-82">
                <div className="flex items-center gap-4 text-xs text-muted mb-6 font-mono" data-id="element-83">
                  <span data-id="element-84">{post.date}</span>
                  <span className="w-1 h-1 rounded-full bg-border" data-id="element-85" />
                  <span className="flex items-center gap-1" data-id="element-86">
                    <Clock size={12} data-id="element-87" />
                    {post.readTime}
                  </span>
                </div>
                <h3 className="text-xl font-heading font-semibold mb-4 group-hover:text-accent transition-colors leading-snug" data-id="element-88">
                  {post.title}
                </h3>
                <p className="text-muted text-sm leading-relaxed mb-8 flex-grow" data-id="element-89">
                  {post.excerpt}
                </p>
                <div className="mt-auto flex items-center gap-2 text-sm font-medium text-foreground group-hover:text-accent transition-colors" data-id="element-90">
                  Artikel lesen
                  <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" data-id="element-91" />
                </div>
              </div>
            </motion.article>)}
        </div>

        {blogPosts.length > 3 && <div className="mt-12 text-center" data-id="element-92">
            <button onClick={onViewAll} className="inline-flex items-center gap-2 border border-border hover:border-accent text-muted hover:text-accent px-8 py-3 transition-all group" data-id="element-93">
              Weitere {blogPosts.length - 3} Artikel entdecken
              <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" data-id="element-94" />
            </button>
          </div>}
      </div>
    </section>;
}